import React from 'react';
import ReactDOM from 'react-dom';
import './fonts/Roboto/Roboto-Black.ttf';
import './fonts/Roboto/Roboto-Bold.ttf';
import './fonts/Roboto/Roboto-Medium.ttf';
import './fonts/Roboto/Roboto-Light.ttf';
import './fonts/Roboto/Roboto-Regular.ttf';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack';
import { CookiesProvider } from 'react-cookie';
import { ProvideAuth } from './components/providers/AuthProvider';
import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
    <React.StrictMode>
        <CookiesProvider>
            <SnackbarProvider maxSnack={10}>
                <ProvideAuth>
                    <Router>
                        <App />
                    </Router>
                </ProvideAuth>
            </SnackbarProvider>
        </CookiesProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
